import { defineStore } from "pinia";

import { useToast } from "vue-toastification";

import { copyableToastOptions } from "@/utils/toastOptionsUtils";
import { toastIdFromText, toastTextWithCount } from "@/utils/toastIdUtils";

export const useErrorStore = defineStore("error", {
  state: () => ({
    error: null,
    toastDuplicateCounts: {},
  }),

  actions: {
    setError(error) {
      this.error = error;
      this.showToast(error);
    },

    clearError() {
      this.error = null;
    },

    showToast(error) {
      const toast = useToast();
      const message = error.message || "Произошла ошибка.";
      const type = error.code === 401 ? "warning" : "error";
      // Один id для одинаковой ошибки заставляет toast обновляться вместо стопки дублей.
      // Счетчик оставляем в тексте, чтобы пользователь видел, что ошибка повторилась.
      const toastId = toastIdFromText(`error-${error.code}`, message);
      const duplicateCount = this.incrementToastDuplicateCount(toastId);
      const toastOptions = {
        timeout: 5000,
        closeOnClick: false,
        id: toastId,
        onClose: () => this.resetToastDuplicateCount(toastId),
      };

      toast[type](
        toastTextWithCount(message, duplicateCount),
        type === "error"
          ? copyableToastOptions(message, toastOptions)
          : toastOptions
      );
    },

    incrementToastDuplicateCount(toastId) {
      const count = (this.toastDuplicateCounts[toastId] || 0) + 1;
      this.toastDuplicateCounts[toastId] = count;

      return count;
    },

    resetToastDuplicateCount(toastId) {
      delete this.toastDuplicateCounts[toastId];
    },
  },
});
